import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    display: 'block',
  },
  background: {
    fill: '#f19e38',
  },
  mark: {
    fill: '#ffffff',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <rect className={classes.background} width="512" height="512" />
      <path
        className={classes.mark}
        d="M382.2,144.4c-12.4-13-32.8-19.5-61.2-19.5H121.7c-7.4,0-11.1,4-11.1,11.4v240.3c0,5.6,2.8,8.4,8.7,8.4h39.9 c5.6,0,8.4-2.8,8.4-8.4v-71.1h153.4c28.5,0,48.9-6.5,61.2-19.5c12.4-12.7,18.6-31.9,18.6-56.9v-27.5 C400.7,176.2,394.5,157.4,382.2,144.4z M344.1,223.6c0,11.1-2.8,19.2-7.7,24.7c-5.3,5.6-14.2,8-26.9,8h-142v-75.5 c0-3.1,1.5-4.6,4.6-4.6h137.3c12.7,0,21.7,2.8,26.9,8c5,5.6,7.7,13.9,7.7,25.1V223.6z"
      />
    </svg>
  );
};
